import {Edge, Node} from 'reactflow';

import {EntityMapEntityNode, EntityMapEdgeNode} from 'graphql-client/__generated/graphqlGlobalTypes';
import getTestProps from 'test/lib/cypress/getTestProps';

/**
 * Converts an EntityMapEntityNode to a ReactFlow Node
 *
 * @param entity The EntityMapEntityNode to convert
 * @returns The ReactFlow Node
 */
export function entityMapEntityNodeToReactFlowNode(entity: EntityMapEntityNode): Node {
  return {
    id: entity.id,
    type: 'entity',
    data: {
      entityId: entity.id,
    },
    position: {x: 0, y: 0},
  };
}

/**
 * Converts an EntityMapEdgeNode to a ReactFlow Edge
 *
 * @param edge The EntityMapEdgeNode to convert
 * @returns The ReactFlow Edge
 */
export function entityMapEdgeNodeToReactFlowEdge(edge: EntityMapEdgeNode): Edge {
  return {
    id: edge.id,
    source: edge.sourceId,
    target: edge.targetId,
    ...getTestProps({component: 'EntityMapEdge', key: edge.id}),
  };
}
